import { useState, useEffect } from "react";
import { PostApiMethod } from "../../core/services/apiService";

export const useChartData = (apiEndpoint: string, payload: any, onChartLoaded: any) => {
    const [chartData, setChartData] = useState<any>(null);
    const [loaded, setLoaded] = useState(false);


    useEffect(() => {
        let isMounted = true;
        (async () => {
            try {
                const response = await PostApiMethod(apiEndpoint, payload);
                const labels: string[] = [];
                const data: number[] = [];

                response?.data?.data?.forEach((element: any) => {
                    const date = Object.keys(element)[0];
                    const value = element[date];
                    // Append time to prevent timezone offset issues
                    // This ensures dates are interpreted in local timezone, not UTC
                    const dateWithTime = date?.includes(':') ? date : `${date}T12:00:00`;
                    labels.push(dateWithTime);
                    data.push(value);
                });

                let startDtTime = "";
                let endDtTime = "";
                if (labels?.length > 0) {
                    startDtTime = labels[0];
                    endDtTime = labels[labels?.length - 1];
                }
                const options: any = {
                    chart: {
                        id: "line-chart",
                        type: "line",
                        zoom: { enabled: true },
                        toolbar: {
                            show: true,
                            tools: {
                                download: true,
                                selection: false,
                                zoom: false,
                                zoomin: false,
                                zoomout: false,
                                pan: false,
                                reset: false,
                            },
                        },
                    },
                    stroke: { curve: "smooth", width: 2 },
                    xaxis: {
                        categories: labels,
                        type: "datetime",
                        min: new Date(startDtTime)?.getTime(),
                        max: new Date(endDtTime)?.getTime(),
                        labels: {
                            datetimeUTC: false,
                            rotate: -45,
                            trim: false,
                            rotateAlways: true,
                            style: { fontSize: "12px" },
                            datetimeFormatter: {
                                year: 'yyyy',
                                month: 'MMM \'yy',
                                day: 'dd MMM',
                                hour: 'hh:mm TT'
                            }
                        }
                    },
                    grid: { padding: { bottom: 20 } },
                    yaxis: { title: { text: "Value" }, style: { fontSize: "16px" } },
                    dataLabels: { enabled: false },
                    markers: {
                        size: 4,
                        colors: ["#439a43"],
                        strokeColors: "#00ff80",
                        strokeWidth: 2,
                        hover: { size: 7 },
                    },
                };

                const series = [{ name: "count", data }];
                const count = data?.reduce((sum, val) => sum + val, 0);
                if (isMounted) {
                    setChartData({ options, series, count });
                    if (!loaded) {
                        onChartLoaded?.();
                        setLoaded(true);
                    }
                }
            } catch (err) {
                console.error("Error fetching chart data:", err);
            }
        })();
        return () => { isMounted = false };
    }, [apiEndpoint, JSON.stringify(payload)]);

    return chartData;
};
